module.exports = __webpack_public_path__ + "img/蒙版组 13.3b655f76.png";